import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';

@Component({
  selector: 'ui-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  host: { class: 'flex items-center justify-start w-full p-4 bg-(--background-block-secondary)' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressSpinnerModule],
})
export class LoadingIndicatorComponent {
  readonly loadingLabel = input('Načítám&hellip;');
}
